import { registerComponents } from '@workbench/load-utils/dist/components';
import { addComponentStyles, addGlobalStyles } from '@workbench/load-utils/dist/styles';

export function loadWorkbench(): Promise<void> {
  return Promise.resolve(registerComponents({ prefixes: ['wb7'] }));
}

export async function loadWorkbenchCss(el: HTMLElement): Promise<void> {
  if (el.shadowRoot && 'CSSStyleSheet' in window) {
    // waiting on WB styles to load to avoid Flash of Unstyled Content (FOUC)
    await Promise.all([
      // Add Workbench component styles to the shadow root
      addComponentStyles(el.shadowRoot),
      // Add Workbench global styles to the shadow root
      addGlobalStyles(el.shadowRoot),
    ]);
  }
}
